(() => {
 'use strict';
 if(customElements.get('gameday-family-tabs'))return;
 class FamilyTabs extends HTMLElement {
  connectedCallback(){
   if(this.initialized)return;this.initialized=true;this.tabs=[...this.querySelectorAll('[data-family]')];this.selection=0;
   this.tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>this.select(index));tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;else if(event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.tabs.length-1;else return;event.preventDefault();this.tabs[next].focus();this.select(next);});});
  }
  async select(index){
   this.selection=index;const tab=this.tabs[index],family=tab.dataset.family;
   this.tabs.forEach((item,i)=>{item.setAttribute('aria-selected',String(i===index));item.tabIndex=i===index?0:-1;});
   this.querySelector('[data-family-panel="usa"]').hidden=family!=='usa';
   const panel=this.querySelector('[data-family-panel="kit"]');panel.hidden=family==='usa';
   if(family==='usa')return;
   panel.setAttribute('aria-labelledby',tab.id);
   if(!panel.firstElementChild)panel.append(this.querySelector('[data-family-template]').content.cloneNode(true));
   await customElements.whenDefined('gameday-kit-hero');
   if(index!==this.selection)return;
   const kit=panel.querySelector('gameday-kit-hero');kit.selectKit(family);
  }
 }
 customElements.define('gameday-family-tabs',FamilyTabs);
})();
